// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit } from '@angular/core';
import { SPAAuthService } from '@app/core/services/spa-auth.service';

const stage = STAGE;

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent {
  picture = '';
  url =
    stage && stage.toLowerCase().includes('prod')
      ? 'https://myprofile.lfx.linuxfoundation.org/'
      : 'https://myprofile.dev.platform.linuxfoundation.org/';

  isContentDisplayed = false;

  constructor(private auth: SPAAuthService) {
    this.setUserPicture();
  }

  setUserPicture() {
    this.auth.getUser$().subscribe(user => {
      console.log('user ?? ', { user });
      this.picture = user.picture;
    });
  }

  logout() {
    this.auth.logout();
  }

  toggleContent() {
    this.isContentDisplayed = !this.isContentDisplayed;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user-info/user-info.component.ts